module.exports = __webpack_public_path__ + "img/dia-no.5e7f57bf.png";